<form [formGroup]="form" class="row">
	<mat-form-field appearance="fill" class="col">
		<mat-label>{{label.length > 0 ? label : 'Select Service Period' + (isMultiple ? '(s)' : '')}}
		</mat-label>
		<mat-select formControlName="servicePeriodSelect" *ngIf="this.isMultiple" [multiple]="isMultiple"
			(openedChange)="onOpen($event)" [required]="required">

			<div class="padding-md text-center row">
				<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6" *ngIf="isMultiple">
					<button color="primary" mat-raised-button (click)="selectAll()"
						style="font-size:6px;padding: 3px 5px;">
						Select All
					</button>
				</div>
				<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
					<button color="accent" mat-raised-button (click)="deSelectAll()"
						style="font-size:6px !important;padding: 3px 5px;">
						Deselect <span *ngIf="isMultiple">All</span>
					</button>
				</div>
			</div>

			<div class="text-center padding-md" *ngIf="isLoading">
				<mat-icon>
					<mat-spinner diameter="13"> </mat-spinner>
				</mat-icon>
				Loading
			</div>

			<mat-option [hidden]="true">Select</mat-option>
			<div [hidden]="isLoading">
				<mat-option class="scrollable-panel-location" *ngFor="let servicePeriod of filteredServicePeriods"
					[value]="servicePeriod">
					{{servicePeriod.PERIOD}}
				</mat-option>
			</div>
		</mat-select>

		<mat-select placeholder="Select Service Period" formControlName="servicePeriodSelect" *ngIf="!this.isMultiple"
			(openedChange)="onOpen($event)" [required]="required">

			<div class="padding-md text-center" class="row">
				<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
					<button color="accent" mat-raised-button (click)="deSelectAll(); close();">
						Deselect
					</button>
				</div>
			</div>

			<div class="text-center padding-md" *ngIf="isLoading">
				<mat-icon>
					<mat-spinner diameter="13"> </mat-spinner>
				</mat-icon>
				Loading
			</div>

			<mat-option [hidden]="true">Select</mat-option>
			<div [hidden]="isLoading">
				<mat-option *ngFor="let servicePeriod of this.filteredServicePeriods" [value]="servicePeriod">
					{{servicePeriod.PERIOD}}
				</mat-option>
			</div>
		</mat-select>
	</mat-form-field>
</form>